import { AnimatePresence } from "framer-motion"
import { Outlet } from "react-router-dom"
import { CalendarProvider } from "./CalendarContext"

export const CalendarPortal = () => {

    return (
        <AnimatePresence mode="wait" initial={true} presenceAffectsLayout={false}>
             <CalendarProvider>
                <Outlet />
             </CalendarProvider>
        </AnimatePresence>
    )

}